export { default as ExchangeWidget } from './exchange-widget/ExchangeWidget.vue';
export type {
  ExchangeAccountOption,
  ExchangeSummary,
  ExchangeViewState,
  ExchangeWidgetEmits,
} from './exchange-widget/ExchangeWidget.types';

export { default as ExchangeRing } from './exchange-ring/ExchangeRing.vue';
export { useExchangeStore } from './store/exchange.store';
export type {
  AccountMoveAccount,
  AccountMovePath,
  IbanAccountMoveResponse,
  IbanExchangeRequest,
  IbanExchangeResponse,
  IbanInternalTransferRequest,
  IbanInternalTransferResponse,
} from './store/exchange.store';
export { getAccountMovePath, isSameAccountMove } from './store/account-move.helpers';
export { extractApiErrorMessage } from './store/exchange.boundary';

import en from './locales/en.json';
import de from './locales/de.json';

export const exchangeLocales = {
  en: { exchange: en },
  de: { exchange: de },
};
